<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="closeSelf()"
  (closed)="closeSelf()"
  [title]="'SCHEDULE.PLANNING.DELETE_MODAL_TITLE' | translate : { title: event.title }"
  [submitText]="'SCHEDULE.PLANNING.DELETE_MODAL_SUBMIT' | translate"
  [loading]="isLoading$ | async"
  [hideCancelOnLoading]="true"
>
  <div class="text-lg font-bold mb-1" translate>SCHEDULE.PLANNING.DELETE_MODAL_SURE</div>
  <div translate>SCHEDULE.PLANNING.DELETE_MODAL_CONTENT</div>
  <mat-checkbox *ngIf="slotRepeat" class="mt-base" [(ngModel)]="deleteAll">{{
    'SCHEDULE.PLANNING.DELETE_MODAL_DELETE_ALL_OCCURRENCES' | translate
  }}</mat-checkbox>
</rk-modal-wrapper>
